import { render, staticRenderFns } from "./MonitoringHistoryComplaint.vue?vue&type=template&id=d50470b8"
import script from "./MonitoringHistoryComplaint.vue?vue&type=script&lang=js"
export * from "./MonitoringHistoryComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports